import { render } from "./OidoSectionHeading.vue?vue&type=template&id=819dc8de&scoped=true"
import script from "./OidoSectionHeading.vue?vue&type=script&lang=js"
export * from "./OidoSectionHeading.vue?vue&type=script&lang=js"

import "./OidoSectionHeading.vue?vue&type=style&index=0&id=819dc8de&scoped=true&lang=css"
import "./OidoSectionHeading.vue?vue&type=style&index=1&id=819dc8de&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-819dc8de"]])

export default __exports__